import React, { useEffect, useState } from "react";
import Card from "components/Card/Card";
import {
  Text,
  Flex,
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  Tooltip,
  TableContainer,
  Button,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Textarea,
  SimpleGrid,
  useColorMode,
  useColorModeValue,
  Box,
  Input,
  Switch,
  Skeleton,

} from "@chakra-ui/react";
import ReactSelect from "react-select";
import axios from "axios";
import apiUrl from "variables/api";
import darkStyles from "variables/darkStyles"

import { toast } from "react-toastify";

function Page() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: isOpenNorms, onOpen: onOpenNorms, onClose: onCloseNorms } = useDisclosure();
  const [minutesText, setMinutesText] = useState("");
  const [minutesText2, setMinutesText2] = useState("");
  const [table, setTable] = useState({});
  const [selectedTable, setSelectedTable] = useState({});
  const [okres, setOkres] = useState({});
  const { colorMode } = useColorMode();
  const [options, setOptions] = useState([]);
  const [subbmiting, setSubbmiting] = useState(false);
  const [subbmitingNorm, setSubbmitingNorm] = useState(false);


  const handleSendMinutes = async () => {
    try {
      setSubbmiting(true);
      axios
        .post(
          apiUrl + "/data/minutesOsp",
          { week1: minutesText, week2: minutesText2 },
          {
            headers: { "x-access-token": localStorage.getItem("token") },
          }
        )
        .then((response) => {
          if (response.data.success) {
            onClose();
            setSubbmiting(false);
            return toast.success("Pomyślnie wysłano minuty");
          } else {
            setSubbmiting(false);
            return toast.error("Napotkano błąd podczas wysyłania minut");
          }
        })
        .catch((error) => {
          console.error(error);
          setSubbmiting(false);
          toast.error("Napotkano błąd podczas połączenia z API");
        });
    } catch (error) {
      console.error("Error sending data", error);
    }
  };



  useEffect(() => {
    axios
      .get(apiUrl + "/data/minutesOsp", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        console.log(response.data);
        setTable(response.data);
        const newOptions = response.data.map((record, index) => ({
          value: record.period,
          label: `#${record.period} ${record.periodDate}`,
          index: index,
        }));
        setOptions(newOptions);
        setOkres(newOptions[0]);
      })
      .catch((error) => {
        console.error(error);
        toast.error("Napotkano błąd podczas połączenia z API");
      });
      axios
      .get(apiUrl + "/data/minutes/normy", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        console.log(response.data);
      })
      .catch((error) => {
        console.error(error);
        toast.error("Napotkano błąd podczas połączenia z API");
      });
  }, [subbmiting, subbmitingNorm]);






  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
      <Card minH="125px">
        <SimpleGrid columns={{ sm: 1, md: 3, xl: 3 }} spacing="24px" mb="20px">
          <ReactSelect
          noOptionsMessage={() => "Brak dostępnych opcji"}
            options={options}
            placeholder="Wybierz..."
            styles={darkStyles()}
            value={okres}
            onChange={setOkres}
          />
          <Button onClick={onOpen}>Uzupełnianie minut</Button>
        </SimpleGrid>
        {table[okres?.index]?.data && (
                  <TableContainer>
                  <Table variant="striped">
                    <Thead>
                      <Tr>
                        <Th>Nick</Th>
                        <Th isNumeric>Minuty</Th>
                        <Th isNumeric>Wyjazdy (in game)</Th>
                        <Th isNumeric>Karty (swd)</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                                              <Tr>
                        <Th>Członkowie OSP</Th>
                      </Tr>
                      {table[okres?.index]?.data?.osp?.map((option) => (
                        <Tr
                          fontWeight="bold"
                          key={option.nick == "brak" ? option.login : option.nick}
                        >
                          <Td>{option.nick == "brak" ? option.login : option.nick}</Td>
                          <Td isNumeric>{option.liczba_minut_total}</Td>
                          <Td isNumeric>{option.liczba_wyjazdow + option.liczba_wyjazdow_week2}</Td>
                          <Td isNumeric>{option.liczba_kart + option.liczba_kart_week2}</Td>
                        </Tr>
                      ))}
                      <Tr>
                        <Th>Inni</Th>
                      </Tr>
                      {table[okres?.index]?.data?.inne?.map((option) => (
                        <Tr
                          fontWeight="bold"
                          key={option.nick == "brak" ? option.login : option.nick}
                        >
                          <Td>{option.nick == "brak" ? option.login : option.nick}</Td>
                          <Td isNumeric>{option.liczba_minut_total}</Td>
                          <Td isNumeric>{option.liczba_wyjazdow + option.liczba_wyjazdow_week2}</Td>
                          <Td isNumeric>{option.liczba_kart + option.liczba_kart_week2}</Td>
                        </Tr>
                      ))}
                      
                    </Tbody>
                    <Tfoot>
                      <Tr>
                        <Th>Nick</Th>
                        <Th isNumeric>Minuty</Th>
                        <Th isNumeric>Wyjazdy (in game)</Th>
                        <Th isNumeric>Karty (swd)</Th>
                      </Tr>
                    </Tfoot>
                  </Table>
                </TableContainer>
        )}
      </Card>

      <Modal isOpen={isOpen} onClose={onClose} size="4xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Uzupełnij Minuty</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex direction={"column"} gap={5}>
              <Box>
                <Text>Dane minut dla tygodnia 1</Text>
                <Textarea
                  placeholder="Wprowadź dane minut..."
                  value={minutesText}
                  onChange={(e) => setMinutesText(e.target.value)}
                  maxH={"500px"}
                />
              </Box>
              <Box>
                <Text>Dane minut dla tygodnia 2</Text>
                <Textarea
                  placeholder="Wprowadź dane minut..."
                  value={minutesText2}
                  onChange={(e) => setMinutesText2(e.target.value)}
                  maxH={"500px"}
                />
              </Box>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="red" mr={3} onClick={handleSendMinutes} isLoading={subbmiting}>
              Akceptuj
            </Button>
            <Button onClick={onClose}>Anuluj</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
}

export default Page;
